import { FC } from 'react'

import InputItem from '../../../../../components/InputItem'
import { ITabBaseProps } from '../types'
import { getFLAGCarbonValue } from '../utils'

// Original Net Carbon Emissions is the only required field on this tab (story 36911).
export const Emissions: FC<ITabBaseProps> = ({ formik }) => {
  const flagNetCarbon = getFLAGCarbonValue(formik.values)

  return (
    <div className="piece-content-inputs mb-5">
      <InputItem
        name="Original Net Carbon Emissions"
        description="Please provide carbon emissions in g CO2 eq."
        type="input"
        addonTitle="g"
        onChange={formik.handleChange}
        formikName="carbon"
        showAsterisk
        formik={formik}
        defaultValue={formik.values.carbon === 0 ? '0' : formik.values.carbon ?? ''}
      />
      <InputItem
        disabled
        name="FLAG Net Carbon Emissions"
        description="FLAG carbon emissions in g CO2 eq."
        type="input"
        addonTitle="g"
        onChange={formik.handleChange}
        defaultValue={flagNetCarbon}
      />
      <InputItem
        name="Total Land Use Change Emissions"
        description="Please provide emissions in g CO2 eq."
        type="input"
        addonTitle="g"
        onChange={formik.handleChange}
        formikName="flag_L1_LandUseChangeCarbon"
        formik={formik}
        defaultValue={formik.values.flag_L1_LandUseChangeCarbon ?? ''}
      />
      <InputItem
        name="Total Land Management, CO2 Emissions"
        description="Please provide carbon emissions in g CO2 eq."
        type="input"
        addonTitle="g"
        onChange={formik.handleChange}
        formikName="flag_L1_LandManagementCarbon"
        formik={formik}
        defaultValue={formik.values.flag_L1_LandManagementCarbon ?? ''}
      />
      <InputItem
        name="Total Land Management, Non-CO2 Emissions"
        description="Please provide emissions in g CO2 eq."
        type="input"
        addonTitle="g"
        onChange={formik.handleChange}
        formikName="flag_L1_LandManagementNonCarbon"
        formik={formik}
        defaultValue={formik.values.flag_L1_LandManagementNonCarbon ?? ''}
      />
      <InputItem
        name="Total Non-land Emissions"
        description="Please provide emissions in g CO2 eq."
        type="input"
        addonTitle="g"
        onChange={formik.handleChange}
        formikName="flag_L1_NonLandCarbon"
        formik={formik}
        defaultValue={formik.values.flag_L1_NonLandCarbon ?? ''}
      />
      <InputItem
        name="Total Unverified Removals"
        description="Please provide emissions removed in g CO2 eq."
        type="input"
        addonTitle="g"
        onChange={formik.handleChange}
        formikName="flag_L1_UnverifiedRemovalsCarbon"
        formik={formik}
        defaultValue={formik.values.flag_L1_UnverifiedRemovalsCarbon ?? ''}
      />
      <InputItem
        name="Total Verified Removals"
        description="Please provide emissions removed in g CO2 eq."
        type="input"
        addonTitle="g"
        onChange={formik.handleChange}
        formikName="flag_L1_VerifiedRemovalsCarbon"
        formik={formik}
        defaultValue={formik.values.flag_L1_VerifiedRemovalsCarbon ?? ''}
      />
    </div>
  )
}
